import type { ReactNode } from 'react'

const Icon = ({ children, className }: { children: ReactNode; className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    {children}
  </svg>
)

export const PanelIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
    <path d="M14.5 4.5v15" />
    <path d="M17 9h1M17 12h1" />
  </Icon>
)

/** A screen with a bar along its foot: the plan sections pinned to the bottom. */
export const DockIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
    <path d="M3.5 15.5h17" />
  </Icon>
)

export const GridIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <rect x="4" y="4" width="6" height="6" rx="1.5" />
    <rect x="14" y="4" width="6" height="6" rx="1.5" />
    <rect x="4" y="14" width="6" height="6" rx="1.5" />
    <rect x="14" y="14" width="6" height="6" rx="1.5" />
  </Icon>
)

export const ViewIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M9.5 9.5v10" />
  </Icon>
)

export const ChevronIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 10 10" aria-hidden="true">
    <path d="M2 3.5 5 6.5 8 3.5" />
  </svg>
)

export const RecalcIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <path d="M19.5 12a7.5 7.5 0 0 1-13.2 4.9M4.5 12a7.5 7.5 0 0 1 13.2-4.9" />
    <path d="M17.9 3.6v3.6h-3.6M6.1 20.4v-3.6h3.6" />
  </Icon>
)

export const BellIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <path d="M6.5 16.5V11a5.5 5.5 0 0 1 11 0v5.5l1.5 2h-14l1.5-2Z" />
    <path d="M10 20.5a2 2 0 0 0 4 0" fill="none" />
  </Icon>
)

export const ReadyIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <circle cx="12" cy="12" r="8" />
    <path d="m8.5 12.2 2.4 2.4 4.6-4.9" />
  </Icon>
)

export const BracesIcon = ({ className }: { className?: string }) => (
  <Icon className={className}>
    <path d="M8 4.5c-2 0-2.5 1-2.5 2.5v2.5c0 1.2-.8 2-2 2.5 1.2.5 2 1.3 2 2.5V17c0 1.5.5 2.5 2.5 2.5M16 4.5c2 0 2.5 1 2.5 2.5v2.5c0 1.2.8 2 2 2.5-1.2.5-2 1.3-2 2.5V17c0 1.5-.5 2.5-2.5 2.5" />
  </Icon>
)
